module.exports = __webpack_public_path__ + "img/Syg_icon_tewt.998a2d97.png";